import React from "react";
import styled from "styled-components";
import * as colors from "../../../util/colors";
import { NAVIGATION_BREAKPOINT } from "../../../constants/layout";
import { DEFAULT_FONT_FAMILY } from "../../../util/typography/base";

const ResponsiveTable = ({children,cssData},props) =>{
    const Table = styled.table`
        width: 100%;
        border: none;
        border-spacing: 0;
        overflow: hidden;

        *{
            font-family: ${DEFAULT_FONT_FAMILY};
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
            @media(max-width:${NAVIGATION_BREAKPOINT}){
                font-size: 9px;
                line-height: 12px;
            }
        }
        .fw-400{
            font-weight: 400;
        }
        .text-center{
            text-align: center;
        }
        .text-nowrap{
            text-wrap-mode: nowrap;
        }
        .text-charcoal{
        color:${colors.charcoal};}
        sub, sup{
            font-size: 70%;
            line-height: 0;
        }
        p{
            margin: 0;
            
        }
        ${(props) => props.cssData ? props.cssData: ""}
    `
    return(
        <Table cssData={cssData} {...props}>
            {children}
        </Table>
    )
}

const ResponsiveHeadData = ({headerData, headerType}) =>{
    const Thead = styled.thead`
        ${(props) => props.headerType === "purple-fill" ? 
            `
                background: ${colors.lightPurple};
                color: ${colors.white};

                th{
                    border-right: 1px solid ${colors.keytrudaGreenBackground};
                    &:last-child{
                        border-right: none;
                    }
                }
            `: props.headerType === "charcoal-fill" ? `
                background: ${colors.charcoal};
                color: ${colors.white};

                th{
                    border-right: 1px solid ${colors.keytrudaGreenBackground};
                    &:last-child{
                        border-right: none;
                    }
                }
            ` :
            ``}
        
    `;

    const Th = styled.th`
        padding: 20px;
        @media(max-width: ${NAVIGATION_BREAKPOINT}){
                padding: 10px 5px 10px 10px;
            }
        width: ${(props)=> props.widthNum ? `calc(100% / ${props.widthNum})`: "100%"};
        text-align:left;
        color: inherit;
    `;
    return(
        <Thead headerType={headerType}>
            {headerData.map((eachHead, index) =>{
                return <Th key={`th-${index}`} widthNum={eachHead.width} colSpan={eachHead.colSpan? eachHead.colSpan : 1}>
                    {eachHead.ThData}
                </Th>
            })}
        </Thead>
    )
}

const ResponsiveRowData = ({rowData}) =>{

    const getRowType = (type) =>{
        if(type === "grey-bg-purple-border") return `
        background: ${colors.silver};

        + tr{
            td{
                border-top: 0px;
            }
        }
        
        td{
            padding: 10px 20px;
            border-color: ${colors.darkPurple};
            border-style: solid;
            border-width: 1px 0;
            color: ${colors.darkPurple};
            text-transform: uppercase;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;

            @media(max-width: ${NAVIGATION_BREAKPOINT}){
                padding: 10px;
                font-size: 9px;
                line-height: 12px;
            }
        }
        `
        if(type === "bg-cloud") return `
         background: ${colors.cloud};
        `
        if(type === "bg-mist") return `
         background: ${colors.mist};
        `
        if(type === "purple-bg") return `
        background: ${colors.lightPurple};
        `
        return `
            
        `
    }

    const Tr = styled.tr`
        background: ${colors.white};
        
        td{
            padding: 20px;
            @media(max-width: ${NAVIGATION_BREAKPOINT}){
                padding: 10px 5px 10px 10px;
            }
            color: ${({type}) => type === 'purple-bg' ? colors.white : colors.ink};
            border-color: ${colors.pebble};
            border-style: solid;
            border-width:1px 1px 0 0;
            &:last-child{
                border-right : none;
            }
        }
        ${(props) =>getRowType(props.type)}
    `;
    return(
        <tbody>
            {rowData.map((eachRow, index) =>{
                return <Tr key={`tr-${index}`} type={eachRow.rowType}>
                    {eachRow.rowTdData.map((eachTd, index) =>{
                        return <td key={`td-${index}`} colSpan={eachTd.colSpan? eachTd.colSpan : 1}>
                            {eachTd.content}
                        </td>
                })}
                </Tr>
            })}
        </tbody>
    )
}


export {ResponsiveTable, ResponsiveHeadData, ResponsiveRowData};